import React, { useEffect } from "react";
import { pendingLogo } from "../../../assets/images";
import { useUser } from "../../../context/user-context";
import { toast } from "react-hot-toast";
import { errorMessage } from "../../../utils/errorMessage";
import useAuthAxios from "../../../utils/baseAxios";
import { API } from "../../../constants/api";
import { useQuery } from "@tanstack/react-query";

const CashbackClaim = ({ setShowClaimModalCashback, claimAmount }: any) => {
  const { userDetails } = useUser();
  const banks = userDetails?.user?.banks;
  const axiosInstance = useAuthAxios();

  const getAllBanks = async () => {
    const response = await axiosInstance.get(API.getBanks);
    return response.data;
  };

  const { data: allBanks, error: error1 } = useQuery({
    queryKey: ["all-banks"],
    queryFn: getAllBanks,
    retry: 1,
  });
  const getAllOldBanks = async () => {
    const response = await axiosInstance.get(API.getBanksDeex);
    return response.data;
  };

  const { data: allOldBanks, error: error2 } = useQuery({
    queryKey: ["all-old-banks"],
    queryFn: getAllOldBanks,
    retry: 1,
  });
  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1, error2]);
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-center px-3 md:px-6 mt-10 items-center flex-col gap-4">
          <div className="w-[116px] h-[116px]">
            <img src={pendingLogo} className="w-full h-full bg-cover" alt="" />
          </div>
          <h4 className="font-sora font-bold text-gray-900 dark:text-gray-100 text-[24px]">
            Claim Cashback (Pending)
          </h4>
          {(() => {
            const defaultBank = Array.isArray(banks)
              ? banks.find((b: any) => b?.isDefault)
              : null;
            if (!defaultBank) return null;
            const matchedBank =
              allBanks?.data.find(
                (allBank: any) => allBank.bankCode === defaultBank.bankCode
              ) ||
              allOldBanks?.data.find(
                (newBank: any) => newBank.code === defaultBank.bankCode
              );
            const receivable = Number(claimAmount ?? 0);
            return (
              <h4 className=" font-medium text-gray-500 dark:text-gray-400 text-center text-[15px]">
                You will receive ₦{receivable.toLocaleString()} as cashback into
                your {""}
                <span className="text-gray-900 dark:text-gray-100 font-semibold text-[13px] pt-2">
                  {defaultBank.accountNumber}
                </span>{" "}
                {"-"}{" "}
                {matchedBank ? (
                  <span className="text-gray-900 dark:text-gray-100 font-semibold text-[13px] pt-2">
                    {matchedBank.bankName || matchedBank.name || "Unknown Bank"}
                  </span>
                ) : null}{" "}
                once approved
              </h4>
            );
          })()}
        </div>
        <button
          onClick={() => {
            setShowClaimModalCashback(false);
          }}
          className="mt-16 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default CashbackClaim;
